export default __webpack_public_path__ + "static/media/ragdoll7M.8997d3da.webp";